// extracted by mini-css-extract-plugin
module.exports = {"img":"Wedding_img__3wWvu","title":"Wedding_title__3AAI9","text":"Wedding_text__1hLZ9","squre_img":"Wedding_squre_img__3io_D"};